import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import PageHeader1 from "../../components/common/PageHeader1";
import { submitMeditationSeriesApi, getMeditationSeriesByIdApi,getMeditationCategories } from "../../services/MeditationSeries";

function CreateMeditationSeries() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [options, setOptions] = useState([""]); // For dynamic options
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [categories, setCategories] = useState([]);

  // Fetch question details if editing
  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getMeditationSeriesByIdApi(id);
        
        if (res?.data) {
        
          const r = res.data;
          setValue("title", r.title);
          setValue("description", r.description);
          setValue("category", r.category);
         
        }
      })();
    }
  }, [id, setValue]);

  useEffect(() => {
    // Fetch categories
    (async () => {
      try {
        const data = await getMeditationCategories();
        if (data.success) {
          console.log("Fetched categories:", data.meditationcategories);
          setCategories(data.meditationcategories || []);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    })();
  }, []);

  // Handle dynamic option field changes
  

  

  // Submit logic
  const onSubmit = async (data) => {
    const payload = {
      ...data,
    };

    if (id) payload._id = id;

    const res = await submitMeditationSeriesApi(payload);
    if (res) {
      // toast.success(id ? "Question updated successfully!" : "Question added successfully!");
      if (!id) {
        reset();
      } else {
        navigate("/meditation-series-list");
      }
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit Meditation Series" : "Add Meditation Series"}
        navigation="Meditation Series"
        navlink="/meditation-series-list"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Question" : "Add New Series"}</h2>
            </div>

            {/* Question Field */}
            <div className="col-md-6">
            <label className="form-label">Category</label>
            <select
              className="form-control"
              {...register("category", { required: "Category is required" })}
            >
              <option value="">Select Category</option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
            {errors.category && (
              <p className="text-danger">{errors.category.message}</p>
            )}
          </div>
            <div className="col-md-6">
              <label className="form-label">Title</label>
              <input
                className="form-control"
                {...register("title", { required: "Title is required" })}
              />
              {errors.title && <p className="text-danger">{errors.title.message}</p>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Description</label>
              <input
                className="form-control"
                {...register("description", { required: "Description is required" })}
              />
              {errors.description && <p className="text-danger">{errors.description.message}</p>}
            </div>
            

            {/* Options Field */}
            

            {/* Submit Buttons */}
            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3">
                {id ? "Update" : "Save"}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/meditation-series-list")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateMeditationSeries;
